module.exports = {"433172598":"乾州街道经开区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/433172.json
// module id = 2069
// module chunks = 0